<IziGrid class="list-game-container">
  <IziCol xl="2" />
  <IziCol xl="8">
    <DataTable :value="games" v-model:selection="game" selectionMode="single" @row-select="selectGame(game)">
      <Column field="name" header="Name">
        <template #body="slotProps">
          <GameCard :game="slotProps.data" />
        </template>
      </Column>
    </DataTable>
  </IziCol>
  <IziCol xl="2" />
</IziGrid>